import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { EnumHelper } from 'src/app/core/helpers/enumHelper';
import { Entities, LicenseServerTypes } from 'src/app/core/models/globals';
import { LicenseServerInterface, NewLicenseServerInterface } from 'src/app/core/models/licenseServer';
import { LicenseServerService } from 'src/app/core/services/license-server.service';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { UserRoleNames } from '../../../../core/models/users';
import { AuthenticationService } from '../../../../core/services/authentication.service';
import { AddLicenseServerComponent } from '../../modals/add-license-server/add-license-server.component';
import { DeleteLicenseServerComponent } from '../../modals/delete-license-server/delete-license-server.component';

@Component({
  selector: 'app-license-parent-list',
  templateUrl: './license-parent-list.component.html',
  styleUrls: ['./license-parent-list.component.scss']
})
export class LicenseParentListComponent implements OnInit {

  licenseServers: LicenseServerInterface[];
  isDataAvailable: boolean = true;
  sortName = 0;
  sortType = 0;
  sortServerAddress = 0;
  p: number = 1;
  isMonitor: boolean = this.authenticationService?.currentUserValue?.role == UserRoleNames.Reader ? true : false;
  isGlobalAdmin = this.authenticationService.isUserGlobalAdmin;
  constructor(
    private _licenseServerService: LicenseServerService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private _navService: NavigationService,
    private snackBar: MatSnackBar,
    private _router: Router,
    private _route: ActivatedRoute,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this._navService.subNavData(Entities.LicenseServer);
    this.spinner.show('licenseServerList');
    this.getLicenseInfoes();
  }

  getLicenseInfoes() {
    this._licenseServerService.getAllLicenseServer()
      .subscribe({
        next: (data: any) => {
          this.spinner.hide('licenseServerList');
          if (data == null) {
            this.isDataAvailable = false;
            return;
          }
          this.licenseServers = JSON.parse(JSON.stringify(data));
          this.isDataAvailable = true;
        },
        error: (err) => {
          this.spinner.hide('licenseSesrverList');
        }
      })
  }

  addLicenseServer() {
    const dialogRef = this.dialog.open(AddLicenseServerComponent, {
      width: '400px',
      autoFocus: false,
      disableClose: true,
    })
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.getLicenseInfoes();
      }
    })
  }

  updateLicenseServer(server: LicenseServerInterface) {
    let updateLicenseObj: NewLicenseServerInterface = {
      name: server.licenseName,
      type: EnumHelper.getValueOfEntry(LicenseServerTypes, server.licenseType),
      host: server.licenseServerAddress.split(":")[0],
      port: +server.licenseServerAddress.split(":")[1]
    }
    const dialogRef = this.dialog.open(AddLicenseServerComponent, {
      width: '400px',
      autoFocus: false,
      disableClose: true,
      data: { licenseObj: updateLicenseObj }
    })

    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.getLicenseInfoes();
      }
    })
  }

  deleteLicenseServer(licenseName: string) {
    const dialogRef = this.dialog.open(DeleteLicenseServerComponent, {
      width: '400px',
      autoFocus: false,
      disableClose: true,
      data: { licenseServerName: licenseName }
    })
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this._licenseServerService.deleteLicenseServer(licenseName).subscribe({
          next: (data: any) => {
            this.snackBar.open(data.message, "Ok", {
              duration: 5000
            });
            this.getLicenseInfoes();
          },
          error: (err) => {
            this.getLicenseInfoes();
          }
        })
      }
    })
  }

  redirectToLicenseInfo(serverName: string, index: number) {
    this._navService.sendChildData(serverName);
    this._router.navigate([`${serverName}/licenses`], {relativeTo: this._route})
  }

  sortByName() {
    if (this.sortName == 0) {
      this.licenseServers.sort((a, b) => 0 - (a.licenseName.toLowerCase() > b.licenseName.toLowerCase() ? 1 : -1));
    }
    if (this.sortName == 1) {
      this.licenseServers.sort((a, b) => 0 - (b.licenseName.toLowerCase() > a.licenseName.toLowerCase() ? 1 : -1));
    }
    this.sortName++
    if (this.sortName == 2) {
      this.sortName = 0;
    }
  }

  sortByType() {
    if (this.sortType == 0) {
      this.licenseServers.sort((a, b) => 0 - (a.licenseType.toLowerCase() > b.licenseType.toLowerCase() ? 1 : -1));
    }
    if (this.sortType == 1) {
      this.licenseServers.sort((a, b) => 0 - (b.licenseType.toLowerCase() > a.licenseType.toLowerCase() ? 1 : -1));
    }
    this.sortType++
    if (this.sortType == 2) {
      this.sortType = 0;
    }
  }

  sortByServerAddress() {
    if (this.sortServerAddress == 0) {
      this.licenseServers.sort((a, b) => 0 - (a.licenseServerAddress.toLowerCase() > b.licenseServerAddress.toLowerCase() ? 1 : -1));
    }
    if (this.sortServerAddress == 1) {
      this.licenseServers.sort((a, b) => 0 - (b.licenseServerAddress.toLowerCase() > a.licenseServerAddress.toLowerCase() ? 1 : -1));
    }
    this.sortServerAddress++
    if (this.sortServerAddress == 2) {
      this.sortServerAddress = 0;
    }
  }
}
